import { jsx as _jsx } from "preact/jsx-runtime";
if (process.env.NODE_ENV === 'development') {
    require('preact/debug');
}
import { render } from 'preact';
import ProjectFinder from './components/ProjectFinder';
const container = document.querySelector('.project-finder__app');
if (container) {
    render(_jsx(ProjectFinder, {}, void 0), container);
}
